import makeList from './makeList.js'

let viewFloor = '多目的大型アンテナレドーム'

let params = [
  {
    name: 'syowa',
    locations: [
      { description: '多目的大型アンテナレドーム(1)',
        file: './data/I45a.JPG',
        rotation: -166.0632842149826,
        link: [
          {
            file: './data/I45.JPG',
            position: [ -1702.1254937251776, 434.95514969878894, -4673.112134340386 ],
          },
          {
            file: './data/I45b.JPG',
            position: [ 4961.754360214345, 311.60882537710916, -496.15912048878283 ],
          },
        ],
        info: [
        ],
        view: {
          syowa: [ 225.64102564102566, 89.74358974358977 ],
          syowaZoom: [ 825.6410256410257, 410.43589743589735 ],
        },
      },
      { description: '多目的大型アンテナレドーム(2)',
        file: './data/I45b.JPG',
        rotation: -144.44684524678252,
        link: [
          {
            file: './data/I45a.JPG',
            position: [ -3795.9048623542812, 1326.9649230043915, 2955.9273986694448 ],
          },
        ],
        info: [
        ],
        view: {
          syowa: [ 212.82051282051285, 82.05128205128207 ],
          syowaZoom: [ 705.1282051282052, 351.46153846153845 ],
        },
      },
      /*
       */
    ],
  },
]

export default makeList(params,viewFloor)
